module.exports = __webpack_public_path__ + "static/screen-classic-laptop@2x-386eae7239dee94e84dde1683953e30d.png";